var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 530.17 134.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#acb236;}.cls-10,.cls-11,.cls-12,.cls-3,.cls-5,.cls-7,.cls-8,.cls-9{mix-blend-mode:soft-light;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#a7ad37;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#bbca39;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 146.17,
    y1: 91.66,
    x2: 146.17,
    y2: 91.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 107.27,
    y1: 78.25,
    x2: 55.7,
    y2: 78.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 21.62,
    y1: 33.19,
    x2: 21.62,
    y2: 67.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 142.75,
    y1: 67.4,
    x2: 142.75,
    y2: 94.66,
    gradientTransform: "translate(-52.05 250.81) rotate(-90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -50.99,
    y1: 179.64,
    x2: -50.99,
    y2: 206.9,
    gradientTransform: "translate(63.88 298.93) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -39.17,
    y1: -9.08,
    x2: -39.17,
    y2: 24.43,
    gradientTransform: "matrix(0.46, 0.89, -0.89, 0.46, 105.59, 51.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 138.33,
    y1: 62.98,
    x2: 138.33,
    y2: 85.92,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Perfect horizontal without slogan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.21,120.83V49.88h30q10,0,14.64,5.91Q225,60.92,225,71.3a38.6,38.6,0,0,1-1.26,10.42,19.56,19.56,0,0,1-3.06,6.69,12.23,12.23,0,0,1-4.5,3.53,16.39,16.39,0,0,1-4.61,1.51,26.3,26.3,0,0,1-3.25.24c-.9,0-1.77,0-2.61,0s-2.75-.18-5.72-.44Q188.13,92,187.45,91.75v29.08Zm29.37-60.58H187.45V83.41h18.13a7.3,7.3,0,0,0,6-2.52c1.39-1.68,2.09-4.84,2.09-9.5q-.1-7.85-3.79-10.08A8,8,0,0,0,205.58,60.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.4,75.27a13.75,13.75,0,0,1,7.27-5.14A38.51,38.51,0,0,1,253.51,69c3.65,0,6.33.07,8.05.19a32.63,32.63,0,0,1,5.18.83,10.34,10.34,0,0,1,4.17,1.89,13.18,13.18,0,0,1,2.81,3.29q2.43,3.69,2.43,12.31,0,12.51-14,12.51H243.87q0,7.56,2.52,9.79a6.58,6.58,0,0,0,3.15,1.65,74.79,74.79,0,0,0,10.32.38,99.57,99.57,0,0,0,15.32-1.06v7.85q-7.95,2.72-25.59,2.71-9.71,0-13.33-5.86T232.62,95Q232.62,80.41,236.4,75.27ZM264.9,87.1q0-5.82-1.6-7.37t-7.61-1.55q-7.65,0-9.21,1.74a8.82,8.82,0,0,0-2.32,5.19,61,61,0,0,0-.29,6.15H260C263.25,91.26,264.9,89.88,264.9,87.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.38,72.36a25.67,25.67,0,0,1,5.14-2.42,20.74,20.74,0,0,1,7.17-1.16,15.2,15.2,0,0,1,5.52.68v11a51.77,51.77,0,0,0-7.36-.39,24.79,24.79,0,0,0-8.24,1.21,21,21,0,0,0-7,4.51v35.09H284.38V69.36h9.12l2.13,6.49C297.5,74.37,299.08,73.2,300.38,72.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.8,78.57V71l8.53-1.65v-9.6q0-15.12,14-15.12A38.6,38.6,0,0,1,357.57,47v6.88l-10.28-.1A6.1,6.1,0,0,0,342.83,55a3.73,3.73,0,0,0-1.16,2.86c-.06,1.33-.1,2.64-.1,3.93v7.56h12.7v9.21h-12.7v42.26H330.33V78.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.06,75.27a13.71,13.71,0,0,1,7.27-5.14A38.51,38.51,0,0,1,381.17,69c3.65,0,6.33.07,8.05.19a32.63,32.63,0,0,1,5.18.83,10.34,10.34,0,0,1,4.17,1.89,13.18,13.18,0,0,1,2.81,3.29q2.43,3.69,2.42,12.31,0,12.51-13.95,12.51H371.53c0,5,.83,8.3,2.52,9.79a6.58,6.58,0,0,0,3.15,1.65,74.79,74.79,0,0,0,10.32.38,99.43,99.43,0,0,0,15.31-1.06v7.85q-7.93,2.72-25.59,2.71-9.69,0-13.32-5.86T360.28,95Q360.28,80.41,364.06,75.27Zm28.5,11.83q0-5.82-1.6-7.37c-1.07-1-3.6-1.55-7.61-1.55q-7.65,0-9.21,1.74a8.82,8.82,0,0,0-2.32,5.19,61,61,0,0,0-.29,6.15h16.09C390.91,91.26,392.56,89.88,392.56,87.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M414.37,113.7a28.12,28.12,0,0,1-2.33-7.56,66.61,66.61,0,0,1-.87-11.82,56.63,56.63,0,0,1,1.21-12.46A18.29,18.29,0,0,1,416,73.77a13.18,13.18,0,0,1,5.28-3.83,19.55,19.55,0,0,1,6.83-1.07,84.42,84.42,0,0,1,23.17,2.91V79q-10.86-.57-15.9-.58c-3.36,0-5.35,0-6,.1a12.18,12.18,0,0,0-2.08.44,3.82,3.82,0,0,0-1.8,1,10.38,10.38,0,0,0-1.3,1.89,10.7,10.7,0,0,0-1.07,3.06,60.41,60.41,0,0,0-.78,10.76,40.86,40.86,0,0,0,1,10.13q1,3.54,2.86,4.75a11,11,0,0,0,5.77,1.21q7.75,0,16.87-.68l3.1-.19v7.36a34.57,34.57,0,0,1-10.47,2.62c-1.16.06-2,.13-2.62.19s-1.5.12-2.76.15-2.12.06-2.57.1-1.37,0-2.76,0h-3.93a16.6,16.6,0,0,1-4.21-.63,12.84,12.84,0,0,1-4.61-2.37A13.42,13.42,0,0,1,414.37,113.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.79,54.92V69.26h12.8v9.21h-12.8v22.59c0,3.61.4,6.15,1.21,7.6a6.15,6.15,0,0,0,3.64,3,64.4,64.4,0,0,0,7.27,2v7.17H478.25q-12.71,0-12.7-18.42V78.47h-8.73V71.68l8.73-2.42,2.13-14.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M496.32,44.5V40.82H510V44.5h-4.86V58.89h-4.05V44.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M510.64,58.89l1.75-18.07H518l2.35,11.36,2.39-11.36h5.6l1.81,18.07h-4L525,47.81l-2.29,11.08h-4.57l-2.39-11.08-1.09,11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.17,91.71v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.44,72.71l-33-12.66a2.36,2.36,0,0,0-2.63,3.75l35.49,41.06a2.35,2.35,0,0,0,3.36.21l97.3-87.49a2.36,2.36,0,0,0-2.82-3.77L75.52,72.52A2.35,2.35,0,0,1,73.44,72.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.44,72.71l-33-12.66a2.36,2.36,0,0,0-2.63,3.75l35.49,41.06a2.35,2.35,0,0,0,3.36.21L137,50.82C129.61,56.84,97.82,82.8,73.44,72.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.3,81.68v24.4a7.89,7.89,0,0,1-7.89,7.89H29.86A7.89,7.89,0,0,1,22,106.08V54.39a7.89,7.89,0,0,1,4.28-7L69.52,25.08a8,8,0,0,1,7.23,0l24.14,12.4a15.85,15.85,0,0,0,15.55-.59L128,29.8a1.77,1.77,0,0,0-.12-3.09l-48.59-25A13.42,13.42,0,0,0,67,1.72L7.31,32.46A13.41,13.41,0,0,0,.05,44.37v76.87a13.39,13.39,0,0,0,13.39,13.4H132.83a13.39,13.39,0,0,0,13.39-13.4v-64a1.47,1.47,0,0,0-2.44-1.1L130.46,68A18.34,18.34,0,0,0,124.3,81.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22,99.75H.05V44.37A13.41,13.41,0,0,1,7.31,32.46C10.93,30.62,43.19,14.1,43.19,14.1S22,26.32,22,54.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.86,114v20.67H13.49A13.52,13.52,0,0,1,.05,121.24c0-4.11,0-39.76,0-39.76S1,114,29.86,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.21,65.78h1v55.37a13.52,13.52,0,0,1-13.39,13.44l-49.33,0s40.8-.49,40.8-28.56V86.68A20.91,20.91,0,0,1,145.21,65.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36.75,42,27,22.5,67,1.72a13.47,13.47,0,0,1,12.27,0L122.9,24.21s-25.4-13.09-53.38.87C63.86,28,36.75,42,36.75,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M130.46,68c13.32-11.82,15.71,18.94,15.71,19.91,0-1.07,0-17.35,0-30.57a1.49,1.49,0,0,0-2.48-1.11Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfect);
export default __webpack_public_path__ + "static/media/perfect.b33922994c68f64c860760e2bca2b41d.svg";
export { ForwardRef as ReactComponent };